exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gl_chart_dropdown_area{margin-bottom:10px}.plusIcon{font-size:50px;margin:0;font-weight:700;margin-top:-65px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-711d813a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./admin/assets/components/allSavedChartsTemplate.vue
// module id = 28
// module chunks = 0